/**
 * Pure filter used by /tickets to scope the wallet to the current venue
 * app. Extracted so it's unit-testable (Fenton 2026-09-09 caught his
 * Madruga tickets showing up in the Love Inn app).
 *
 * Rules:
 *   - If we don't know the current venue yet, return everything (the
 *     page will re-render when useVenue resolves).
 *   - Otherwise, only keep tickets whose assembly.venueId matches. This
 *     also drops legacy rows with a null venueId, which is intentional:
 *     those rows predate the linkage and can't be attributed to any
 *     venue safely.
 */
type TicketLike = { assembly: { venueId: string | null } };

export function filterTicketsForVenue<T extends TicketLike>(
  tickets: T[],
  currentVenueId: string | null,
): T[] {
  if (!currentVenueId) return tickets;
  return tickets.filter((t) => t.assembly.venueId === currentVenueId);
}
